module.exports = __webpack_public_path__ + "static/media/openfleet-pin-big.02ca7114.svg";